/* unplugin-vue-components disabled */import { render } from "./user.vue?vue&type=template&id=79524fb5&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=79524fb5&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79524fb5"],['__file',"src/pages/tenants/user/user.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79524fb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79524fb5', __exports__)) {
    api.reload('79524fb5', __exports__)
  }
  
  module.hot.accept("./user.vue?vue&type=template&id=79524fb5&scoped=true", () => {
    api.rerender('79524fb5', render)
  })

}


export default __exports__